import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  Segment,
  Dimmer,
  Loader,
  Card,
  Pagination,
  Button,
} from "semantic-ui-react";

import RowCard from "./RowCard";

import Select from "react-select";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  SG_GET_POWERPOINT_REPORT,
  // SG_DELETE_POWERPOINT_REPORT,
  // SG_CREATE_POWERPOINT_REPORT,
  // UPDATE_DEBRIEF_PDF_REPORT_QUERY_PARAMS,
} from "constants/actions";

const PresentationReportList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const [orgSelected, setOrgSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [queryParams, setQueryParams] = useState([]);

  const { presentationReports, pending } = useSelector(
    (state) => ({
      presentationReports: state.presentation_report.reports,
      pending: state.presentation_report.pending,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (queryParams?.length > 0) {
      dispatch({
        type: SG_GET_POWERPOINT_REPORT,
        payload: queryParams.join("&"),
      });
    } else {
      dispatch({
        type: SG_GET_POWERPOINT_REPORT,
      });
    }
  }, [dispatch, queryParams]);

  useEffect(() => {
    setLoading(pending);
  }, [pending]);

  useEffect(() => {
    if (presentationReports) {
      setResults(presentationReports.results);
      setPage(presentationReports.pageNumber);
      setTotalPages(
        Math.ceil(
          presentationReports.count / presentationReports.page_size
        )
      );
    }
  }, [presentationReports]);

  function applyFilters(orgId, pageNumber = 1) {
    let _queryParams = [];

    if (pageNumber) {
      _queryParams.push(`page=${pageNumber}`);
    }

    if (orgId) {
      _queryParams.push(`organization=${orgId}`);
    }

    // dispatch({
    //   type: UPDATE_DEBRIEF_PDF_REPORT_QUERY_PARAMS,
    //   payload: _queryParams,
    // });

    dispatch({
      type: SG_GET_POWERPOINT_REPORT,
      payload: _queryParams.join("&"),
    });
  }

  function UpdateOrganization() {
    applyFilters(orgSelected?.id);
  }

  function handlePageChange(event, value) {
    setPage(value.activePage);

    applyFilters(orgSelected?.id, value.activePage);
  }

  return (
    <Container>
      <SingleRowContent>
        <SectionCell>
          <Select
            name="org_preference"
            options={[]} // Replace with organization options if available
            isClearable
            onChange={setOrgSelected}
            getOptionLabel={(option) => `${option.id} # ${option.name}`}
            getOptionValue={(option) => `${option.id}`}
            value={orgSelected}
          />
        </SectionCell>
        <Button onClick={UpdateOrganization}>Filter</Button>
      </SingleRowContent>

      <Segment id="results" basic>
        <Dimmer active={loading}>
          <Loader />
        </Dimmer>
        <Card.Group>
          {results ? (
            results.map((result) => (
              <RowCard
                row={result}
                key={result?.id}
                ResetUpdates={() => {}}
              />
            ))
          ) : (
            <SectionDiv>
              <p>No results found</p>
            </SectionDiv>
          )}
        </Card.Group>
      </Segment>
      <SectionDiv>
        <Pagination
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          activePage={page}
          totalPages={totalPages ? totalPages : 0}
          onPageChange={handlePageChange}
        />
      </SectionDiv>
    </Container>
  );
};

export default PresentationReportList;

const Container = styled.div`
  margin-bottom: 30px;
`;

const SectionDiv = styled.div`
  padding: 30px 15px;
`;

const SingleRowContent = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 30px 5px;
`;

const SectionCell = styled.div`
  min-width: 350px;
`;